export enum NavigationType {
  Admin = 'admin',
  Footer = 'footer',
  Navbar = 'navbar',
}